module.exports = __webpack_public_path__ + "img/tokped.79693b86.jpg";